import React from 'react';
import './TierBadge.css';

/**
 * TierBadge Component
 * Displays user's subscription tier with appropriate styling
 * Follows the three-tier system: Free (gray), Basic (blue), Pro (purple)
 * Supports legacy/grandfathered tiers with "legacy-" prefix
 */
export default function TierBadge({ tier }) {
  const config = {
    free: { color: 'gray', label: 'Casual', icon: '🆓' },
    basic: { color: 'blue', label: 'Locked-In', icon: '⭐' },
    pro: { color: 'purple', label: 'All-Gas', icon: '💎' },
    custom: { color: 'orange', label: 'Custom', icon: '✨' }
  };

  // Detect legacy tier and extract base tier
  const isLegacy = tier?.startsWith('legacy-');
  const baseTier = isLegacy ? tier.replace('legacy-', '') : tier;
  const tierConfig = config[baseTier?.toLowerCase()] || config.free;
  
  // Add "(Grandfathered)" suffix for legacy tiers
  const displayLabel = isLegacy ? `${tierConfig.label} (Grandfathered)` : tierConfig.label;

  return (
    <span 
      className={`tier-badge tier-badge-${tierConfig.color} ${isLegacy ? 'tier-badge-legacy' : ''}`}
      data-testid={`tier-badge-${tier?.toLowerCase() || 'free'}`}
      title={isLegacy ? 'This plan is no longer available to new users' : ''}
    >
      <span className="tier-badge-icon">{tierConfig.icon}</span>
      <span className="tier-badge-label">{displayLabel}</span>
    </span>
  );
}
